<template>
  <div :class="{section: true, bookContainer: true, mobile: mobile()}">
    <h1 class="headline"><b>Weihnachten stellt uns Gott vor</b><br>
      Möchtest du noch mehr erfahren über Gottes Angebot, dann haben wir noch etwas Lesestoff für dich.
      <br>
      <div class="cButton" @click="openOrder()">Zu meinem Gratisbuch</div>
    </h1>
    <img class="book" src="@/assets/christmas/Glaube_Fuer_Anfaenger_Cover.jpg">

    <img class="moon" src="@/assets/christmas/moon2.svg">
    <img class="grass" src="@/assets/christmas/grass2.svg">
    <img class="stone" src="@/assets/christmas/stone.svg">
    <div class="ground"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import BasicComponent from "@/components/BasicComponent.js";
import Order from "@/views/Order";
@Component({
  components: {Order}
})
export default class Intro extends BasicComponent {

  onActive() {

  }

  mounted() {
    this.register();
  }

  openOrder() {
    this.$emit("order");
  }

}
</script>
<style scoped lang="scss">
@import "@/stylesheets/Christmas.scss";

$mobileBreakWidth: 1000px; // Switch to vertical arrangement
$bookHeight: 60vh;

.bookContainer {
  background-color: $backgroundBlue;
  overflow: hidden !important;
  position: relative;

  .headline {
    color: black;
    font-size: 40px;
    font-weight: 300;

    width: 40%;
    max-width: 600px;
    //color: #000336;
    text-align: left;

    position: absolute;
    top: calc(100vh - #{$bookHeight} - #{$groundHeight});
    left: 50%;
    transform: translateX(5vw);

    b {
      font-weight: 600;
      font-family: "Source Serif Pro";
    }

    @media screen and (max-width: 1200px) {
      font-size: 35px;
    }

    @media screen and (max-width: $mobileBreakWidth) {
      width: 80%;
      left: 50%;
      top: 6%;
      transform: translateX(-50%);
      font-size: 30px;
      z-index: 5;

      b {
        display: block;
        margin-right: 30px;
      }

      @media screen and (max-width: 600px) {
        font-size: 25px;
      }

      @media screen and (max-height: 600px) {
        font-size: 20px;

      }
    }
  }


  .ground {
    z-index: auto !important;
    height: $groundHeight !important;
  }

  .moon {
    height: 15vh;
    max-width: 50vw;
    min-height: 100px;
    position: absolute;
    top: 15vh;
    left: 15%;
    transform: translate(-50%, -50%);
  }

  .stone {
    max-height: 8vh;
    max-width: 5vw;

    position: absolute;
    bottom: $groundHeight;
    left: 10%;
    transform: translateX(-50%);

  }

  .grass {
    width: 80px;
    max-width: 40vw;

    position: absolute;
    bottom: $groundHeight;
    right: 10%;
    transform: translateX(50%);

  }


  .book {
    position: absolute;
    right: 55%;
    height: $bookHeight;
    bottom: $groundHeight;

    @media screen and (max-width: $mobileBreakWidth) {
      height: 30vh;
      right: 50%;
      transform: translateX(50%);
      max-width: unset;
    }
  }

  .cButton {
    font-size: 20px;
    border-radius: 10px;
    background-color: #000336;
    display: inline-block;
    color: white;
    padding: 8px 20px;
    font-weight: normal;
    text-align: center;
    position: relative;
    margin-top: 30px;
    //left: 50%;
    //transform: translateX(-50%);
    z-index: 8;

    &:hover {
      cursor: pointer;
    }

    &.disabled {

      &:hover {
        cursor: not-allowed;
      }

      background-color: #707070;

    }
  }



}

.mobile {
  .title {
    font-size: 10vw;
    transform: translate(-50%, -50%);
    z-index: 200;
  }

}

</style>
